"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _background = require("../../../actions/background");
function backgroundAdded(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var teamId = _ref2.teamId,
    eventId = _ref2.eventId,
    broadcastId = _ref2.broadcastId;
  dispatch((0, _background.getBackgrounds)(teamId, eventId, broadcastId));
}
var _default = exports["default"] = backgroundAdded;